import { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Releases } from '../config/releases.config';
import { useLayout } from '../hooks/layout.hook';

export default function ReleasesScreen(): JSX.Element {
  const { t } = useTranslation();

  useLayout(
    () => ({
      hideFooter: true,
      backButton: true,
      title: t('Release Notes'),
      titleSize: 'text-3xl',
    }),
    [t],
  );

  return (
    <div className="flex flex-col gap-4">
      {Releases.map((release) => (
        <div key={release.version} className="bg-base-100 rounded-box shadow-md p-4 flex flex-col gap-2">
          <div className={`flex items-baseline gap-2 text-lg font-bold`}>
            <span>v{release.version}</span>
            <span className="text-sm text-base-content/50 font-normal">{release.date}</span>
          </div>

          <ul className="list-disc ml-7 text-base-content/70 space-y-1">
            {release.features.map((feature, i) => {
              const [title, ...rest] = feature.split(' - ');
              return (
                <li key={i}>
                  <span className="font-semibold">{title}</span>
                  {rest.length > 0 && ` - ${rest.join(' - ')}`}
                </li>
              );
            })}
          </ul>

          {release.fixes && release.fixes.length > 0 && (
            <div className="text-sm text-base-content/60">
              <span className="font-medium">{t('Bug fixes')}:</span> {release.fixes.join(', ')}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
